import { Opacity } from "@mui/icons-material";
import { useMediaQuery } from "@mui/material";
import { createTheme, useTheme } from "@mui/material/styles";
import { useState, useMemo, createContext } from "react";

// bgcolor:'#161B25' ,
export const newTokens = (mode) => ({
  ...(mode === "dark"
    ? {
        blue: {
          50: "#E6F1FF",
          100: "#B1D5FD",
          200: "#8BC0FD",
          300: "#55A4FC",
          400: "#3592FB",
          500: "#0277FA",
          600: "#026CE4",
          700: "#0154B2",
          800: "#01418A",
          900: "#013269",
        },
        gray: {
          50: "#EDEDEF",
          100: "#C7C8CC",
          200: "#ACAEB4",
          300: "#868991",
          400: "#6E727C",
          500: "#4A4F5B",
          600: "#434853",
          700: "#353841",
          800: "#292B32",
          900: "#1F2126",
        },
        other: {
          red: "#F44336",
          pink: "#E91E63",
          purple: "#9C27B0",
          deepPurple: "#673AB7",
          indigo: "#3F51B5",
          blue: "#2196F3",
          lightBlue: "#03A9F4",
          cyan: "#00BCD4",
          teal: "#009688",
          green: "#4CAF50",
          lightGreen: "#8BC34A",
          lime: "#CDDC39",
          yello: "#FFEB3B",
          amber: "#FFC107",
          orange: "#FF9800",
          deppOrange: "#FF5722",
          brown: "#795548",
          primeryBlue0: " #292B32",
          bgWhite: "rgba(30, 35, 45, 1) ",
          blueInputField: "rgba(53, 56, 65, 1)",
        },
      }
    : {
        blue: {
          50: "#E9F0FF",
          100: "#B9D1FE",
          200: "#98BAFE",
          300: "#689BFE",
          400: "#4B88FD ",
          500: "#1E6AFD",
          600: "#1B60E6",
          700: "#154BB4",
          800: "#113A8B",
          900: "#0D2D6A",
        },
        gray: {
          50: "#FAFAFA",
          100: "#F5F5F5",
          200: "#EEEEEE",
          300: "#E0E0E0",
          400: "#BDBDBD",
          500: "#9E9E9E",
          600: "#757575",
          700: "#616161",
          800: "#424242",
          900: "#F7FBFF",
        },
        other: {
          red: "#F44336",
          pink: "#E91E63",
          purple: "#9C27B0",
          deepPurple: "#673AB7",
          indigo: "#3F51B5",
          blue: "#2196F3",
          lightBlue: "#03A9F4",
          cyan: "#00BCD4",
          teal: "#009688",
          green: "#4CAF50",
          lightGreen: "#8BC34A",
          lime: "#CDDC39",
          yello: "#FFEB3B",
          amber: "#FFC107",
          orange: "#FF9800",
          deppOrange: "#FF5722",
          brown: "#795548",
          primeryBlue0: "#F7FBFF ",
          bgWhite: "rgba(255, 255, 255, 1)",
          blueInputField: " rgba(230, 241, 255, 1)",
        },
      }),
});
export const tokens = (mode) => ({
  ...(mode === "dark"
    ? {
        grey: {
          100: "#e0e0e0",
          200: "#c2c2c2",
          300: "#a3a3a3",
          400: "#858585",
          500: "#666666",
          600: "#525252",
          700: "#3d3d3d",
          800: "#1E232D",
          900: "#161B25",
        },
        primary: {
          100: "#d0d1d5",
          200: "#a1a4ab",
          300: "#727681",
          400: "#1F2A40",
          500: "#141b2d",
          600: "#101624",
          700: "#0c101b",
          800: "#080b12",
          900: "#040509",
        },
        greenAccent: {
          100: "#dbf5ee",
          200: "#b7ebde",
          300: "#94e2cd",
          400: "#70d8bd",
          500: "#4cceac",
          600: "#3da58a",
          700: "#2e7c67",
          800: "#1e5245",
          900: "#0f2922",
        },
        redAccent: {
          100: "#f8dcdb",
          200: "#f1b9b7",
          300: "#e99592",
          400: "#e2726e",
          500: "#db4f4a",
          600: "#af3f3b",
          700: "#832f2c",
          800: "#58201e",
          900: "#2c100f",
        },
        blueAccent: {
          100: "#e1e2fe",
          200: "#c3c6fd",
          300: "#a4a9fc",
          400: "#3592FB",
          500: "#6870fa",
          600: "#535ac8",
          700: "#3e4396",
          800: "#2a2d64",
          900: "#151632",
        },
        bord: {
          100: "#9A40E0",
          200: "#1E6AFD",
          300: "#FFBB0C",
          400: "#4CAF50",
          500: "#1E232D",
          600: "#fff",
          700: "#C7C8CC",
          800: "#55A4FC",
          900: "#FF9800",
          101: "rgba(255, 152, 0, 0.1)",
          201: "rgba(212, 22, 79, 0.1)",
          301: "#F44336",
          401: "#55A4FC",
          501: "#FF9800",
          601: "#D4164F",
        },
      }
    : {
        grey: {
          100: "#141414",
          200: "#292929",
          300: "#3d3d3d",
          400: "#525252",
          500: "#666666",
          600: "#858585",
          700: "#a3a3a3",
          800: "#FFFFFF",
          900: "#F7FBFF",
        },
        primary: {
          100: "#040509",
          200: "#080b12",
          300: "#0c101b",
          400: "#f2f0f0",
          500: "#141b2d",
          600: "#434957",
          700: "#727681",
          800: "#a1a4ab",
          900: "#d0d1d5",
        },
        greenAccent: {
          100: "#0f2922",
          200: "#1e5245",
          300: "#2e7c67",
          400: "#3da58a",
          500: "#4cceac",
          600: "#70d8bd",
          700: "#94e2cd",
          800: "#b7ebde",
          900: "#dbf5ee",
        },
        redAccent: {
          100: "#2c100f",
          200: "#58201e",
          300: "#832f2c",
          400: "#af3f3b",
          500: "#db4f4a",
          600: "#e2726e",
          700: "#e99592",
          800: "#f1b9b7",
          900: "#f8dcdb",
        },
        blueAccent: {
          100: "#151632",
          200: "#2a2d64",
          300: "#3e4396",
          400: "#1E6AFD",
          500: "#6870fa",
          600: "#868dfb",
          700: "#a4a9fc",
          800: "#c3c6fd",
          900: "#e1e2fe",
        },
        bord: {
          100: "#9A40E0",
          200: "#1E6AFD",
          300: "#FFBB0C",
          400: "#4CAF50",
          500: "#fff",
          600: "rgba(0, 0, 0, 0.87)",
          700: "#424242",
          800: "#55A4FC",
          900: "#FF9800",
          301: "#D4164F",
          501: "#FF9800",
          601: "#D4164F",
        },
      }),
});

export const themeSettings = (mode ,theme) => {
  const colors = tokens(mode);


  return {
    palette: {
      mode: mode,
      ...(mode === "dark"
        ? {
            primary: {
              main: colors.primary[500],
            },
            secondary: {
              main: colors.greenAccent[500],
            },
            neutral: {
              dark: colors.grey[700],
              main: colors.grey[500],
              light: colors.grey[100],
            },
            background: {
              default: colors.primary[600],
            },
          }
        : {
            primary: {
              main: colors.primary[100],
            },
            secondary: {
              main: colors.greenAccent[500],
            },
            neutral: {
              dark: colors.grey[700],
              main: colors.grey[500],
              light: colors.grey[100],
            },
            background: {
              default: "#fcfcfc",
            },
          }),
    },
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          input: {
            WebkitBoxShadow: "none",

            // borderColor:' #F7FBFF',
            borderRadius: "8px",
            background: mode === "dark" ? "#262D39" : "#F7FBFF",
            boxShadow: "none",
            fontFamily: "iransansFanum !important",
          },

          root: {
            "&.Mui-focused": {
              "& .MuiOutlinedInput-notchedOutline": {
                border: `1px solid #B1D5FD `,
              },
            },

            "& fieldset": {
              borderColor: `#B1D5FD`,
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {},

            "& fieldset:focus-visible": {
              borderColor: `rgba(30, 106, 253, 0.20)`,
              WebkitBoxShadow: "0 !important",
            },
            "&:hover fieldset": {
              borderColor: "rgba(53, 146, 251, 1) !important",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#F7FBFF",
              WebkitBoxShadow: "0",
            },
          },
        },
      },

      MuiAccordion: {
        styleOverrides: {
          root: {},
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            color: "gray !important ",
            fontSize: "16px",
          },
        },
      },
      MuiPickersDay: {
        styleOverrides: {
          root: {
            "&.Mui-selected": {
              backgroundColor: "red !important ",
            },
          },
        },
      },
      MuiDataGrid: {
        styleOverrides: {
          root: {
            border: 0,
            "& .default-row": {
              backgroundColor: "#8ADAB2",
            },
            "& .MuiDataGrid-columnHeaders": {
              width: "max-content",
              minHeight: "35px !important",
              maxHeight: "35px !important",
              lineHeight: "35px !important",
              position: "sticky",
              zIndex: "1000",
              background: mode === "dark" ? "#353841" : "#B1D5FD",
              [theme.breakpoints.down("xl")]: { minWidth: "100rem !important" },
              [theme.breakpoints.up("xl")]: {
                minWidth: "fit-content!important",
              },
            },
            "& .MuiDataGrid-virtualScroller ": {
              marginTop: "0 !important",
              [theme.breakpoints.down("xl")]: { minWidth: "100rem !important" },
              [theme.breakpoints.up("xl")]: {
                minWidth: "fit-content!important",
              },
              overflowX: "hidden !important",
            },
            "& .MuiDataGrid-main": {
              overflowX: "auto",
            },
            "& .muirtl-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
              fontFamily: "yekan !important",
              fontSize: "11px",
              fontWeight: "500",
              color: mode === "dark" ? "#FFF " : "#000",
            },
            "& .MuiDataGrid-columnHeaderTitleContainer": {
              justifyContent: "center",
            },
            "& .MuiDataGrid-cellContent": {
              margin: "auto",
              fontSize: "11px !important",
              fontFamily: "iransansFanum !important",
            },
            "& .MuiDataGrid-cell ": {
              borderBottom: "0px",
              fontSize: "11px",
            },
            "& .MuiDataGrid-columnSeparator--sideRight": {
              visibility: "hidden",
              display: "none",
            },

            "& .muirtl-oooz60-MuiDataGrid-columnHeaders": {
              borderBottom: "none",
            },
            "& .MuiDataGrid-root.MuiDataGrid-autoHeight.MuiDataGrid-root--densityStandard":
              {
                border: "0",
              },
            "& .MuiDataGrid-row.Mui-selected": {
              backgroundColor: "rgba(154, 64, 224, 0.3)",
              
            },
          },
        },
        MuiTabs: {
          styleOverrides: {
            root: {
              "& button": { borderRadius: 2 },
              "& button:hover": { backgroundColor: "" },
              "& button:active": { backgroundColor: "" },
              "& button.Mui-selected": {
                backgroundColor: "#E6F1FF",
                color: "#1E6AFD",
              },
              "& .muirtl-w6t02z-MuiButtonBase-root-MuiTab-root": {
                minHeight: "0px !important",
              },
              "& .MuiButtonBase-root ": { minHeight: "15px", color: "#1E6AFD" },
            },
          },
        },
      },
    },
    direction: "rtl",

    typography: {
      fontFamily: ["yekan", "Open Sans"].join(","),
    },
  };
};

export const ColorModeContext = createContext({
  toggleColorMode: () => {},
});

export const useMode = () => {
  const localStorageMode = localStorage.getItem("rasamAplicationMod");
  const [mode, setMode] = useState("light");
  const themeHook = useTheme();
  const colorMode = useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prev) => (prev === "light" ? "dark" : "light"));
      },
    }),
    []
  );
  const theme = useMemo(
    () =>
      createTheme(themeSettings(localStorageMode ? localStorageMode : "dark" ,themeHook)),
    [localStorageMode]
  );

  return [theme, colorMode];
};
